import {Component, Input, TemplateRef} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {Device} from "../device";

@Component({
	selector: "device-row-template",
	template: `
		<div
			[ngClass]="{
				'devicerow': true,
				'devicerow-portable': device.model.portable,
				'devicerow-panelmount': !device.model.portable,
				'devicerow-compact': compactView
			}">

			<div class="devicerow_content">
				<div class="devicerow_details">
					<image-container class="devicerow_image" *ngIf="device.model && !compactView"
						[width]="100"
						[height]="80"
						[src]="device.model.imageURL"
						[alt]="device.model.displayName"></image-container>

					<div [class]="(compactView) ? 'devicerow_text devicerow_text-compact' : 'devicerow_text'">
						<h3><div>{{device.name}}</div></h3>
						<p *ngIf="device.model">{{device.model.make}} {{device.model.name}}</p>
					</div>
				</div>
			</div>

			<ng-template #defaultActionButton>
			</ng-template>

			<ng-container
				[ngTemplateOutlet]="formTemplate ? formTemplate : defaultActionButton"
				[ngTemplateOutletContext]="{
					form: form,
					id: device.id
				}">
			</ng-container>

		</div>
	`,
})
export class DeviceRowTemplateComponent {
	@Input() device: Device;
	@Input() compactView: boolean;
	@Input() formTemplate: TemplateRef<any>;
	@Input() form: FormGroup;
	shouldShowStatus: boolean;
	statusClass: string;
	hasExclamationIcon: boolean;
	statusText: string;
	nextUpdateText: string;
	shouldShowInstall: boolean;

	constructor () {}
}
